import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ActionModel, ButtonModel } from 'simpo-component-library/lib/styles/style.model.d';
import { TemplateService } from 'src/app/services/template.service';
import { ListItemComponentComponent } from '../list-item-component/list-item-component.component';
// import { RedirectionLinkType } from 'simpo-component-library/lib/styles';
import { QuillModule } from 'ngx-quill';
import { ProductServiceService } from 'src/app/services/product-service.service';
import { ChannelType, EventsService, TextPosition, RedirectionLinkType } from 'simpo-component-library';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FooterSocialChannelModel } from 'simpo-component-library/lib/sections/footer-section/footer-section.modal';
import { MapService } from 'src/app/services/map.service';
import { map, Observable, startWith } from 'rxjs';
import { FloatingEditor2Component } from '../floating-editor2/floating-editor2.component';
import { EditorEventService } from 'src/app/services/editor-event.service';
import { DbService } from 'src/app/services/db-service/db.service';
import { WarningPopupComponent } from '../../popups/warning-popup/warning-popup.component';
import { WebsiteServiceService } from 'src/app/services/website-service.service';
import { DynamicSectionService } from 'src/app/services/dynamicsection.service';


@Component({
  selector: 'app-content-editor',
  templateUrl: './content-editor.component.html',
  styleUrls: ['./content-editor.component.scss']
})
export class ContentEditorComponent {
  @Input() content: any;
  @Input() style: any;
  @Input() action?: ActionModel;
  @Input() sectionType!: string;
  @Input() color?: string;
  @Input() sectionId!: string;
  @Input() templatePage: any[] = [];
  @Input() currentPageIndex: number = 0;

  public loading: string | null = null;
  categoryList: any[] = [];
  businessType: any;
  bDetails: any;
  activeSubView: any;
  sections: any;
  currentEditTextItem: any;
  Object = Object;
  isDropdownOpen = false;

  constructor(
    private dialogSercvice: TemplateService,
    private websiteService: WebsiteServiceService,
    private _mapservice: MapService,
    private eventEmitter: EventsService,
    private productService: ProductServiceService,
    private _dbService: DbService,
    private _localEventEmitterService: EditorEventService,
    private eventEmitterService: TemplateService,
    private dyanmicService : DynamicSectionService
  ) {
    this.screenSize()
  }

  ngOnInit() {
    console.log(this.content)
    if (this.content?.listItem?.data?.length > 0) {
      this.listItemTemplate = JSON.parse(JSON.stringify(this.content.listItem.data[0]));
      if (!this.content.listItem._template) {
        this.content.listItem._template = this.listItemTemplate;
      }
    }
    this.getCollectionList();
    this.getMenuList();
    this.getAllCategories();
    this.searchLocation = this.content?.address?.name;
    console.log(this.content, this.action);

    let bDetails = window.localStorage.getItem('bDetails') || '';
    if (bDetails) {
      this.bDetails = JSON.parse(bDetails);
      this.businessType = this.bDetails?.type;
    }
    this.initializeSections();

    this.eventEmitterService.focusContentBlock.subscribe((res: { blockType: string; data?: any }) => {
      if (res.blockType === 'text' && res.data) {
        this.editTextInput(res.data);
      } else {
        this.activeSubView = 'main';
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['content'] && this.content?.listItem?.data?.length > 0) {
      this.listItemTemplate = JSON.parse(JSON.stringify(this.content.listItem.data[0]));
      if (!this.content.listItem._template) {
        this.content.listItem._template = this.listItemTemplate;
      }
    }
    this.initializeSections();
  }

  initializeSections() {
    this.sections = [];
    let index = 1;

    // 1. Display Section
    if (this.content && this.content.display) {
      this.sections.push({
        id: 'display',
        num: index++,
        title: 'Display',
        isEnabled: true
      });
    }

    // 2. Text Section
    if (this.content && this.content.inputText && this.content.inputText.length > 0) {
      this.sections.push({
        id: 'text',
        num: index++,
        title: 'Text',
        isEnabled: true
      });
    }

    // 3. List Item Section (Services, Logos, etc.)
    if (this.content && this.content.listItem) {
      const isEnabled = this.content.display ? this.content.display.showIncludeditems : true;
      this.sections.push({
        id: 'listItem',
        num: index++,
        title: this.content.listItem.label || 'List Items',
        isEnabled: isEnabled
      });
    }

    // 4. Buttons Section
    if (this.action && (this.action.buttons || this.action.display !== undefined)) {
      const isEnabled = this.action.hasOwnProperty('display') ? this.action.display : (this.content.display ? this.content.display.showButton : true);
      this.sections.push({
        id: 'buttons',
        num: index++,
        title: this.sectionType === 'image' ? 'Action' : 'Buttons',
        isEnabled: isEnabled
      });
    }

    // 5. Contact Form Section
    if (this.content && this.content.contactField) {
      this.sections.push({
        id: 'contactField',
        num: index++,
        title: 'Form Fields',
        isEnabled: true
      });
    }

    // 6. Address Section
    if (this.content && this.content.address) {
      this.sections.push({
        id: 'address',
        num: index++,
        title: 'Address',
        isEnabled: true
      });
    }

    // 7. Video Link Section
    if (this.content && this.content.videoLink) {
      this.sections.push({
        id: 'videoLink',
        num: index++,
        title: 'Video link',
        isEnabled: true
      });
    }

    // 8. Branding / Site Name Section
    if (this.content && (this.content.siteName || this.content.logo || this.content.siteNameAndLogo)) {
      this.sections.push({
        id: 'branding',
        num: index++,
        title: 'Branding',
        isEnabled: true
      });
    }

    // 9. Collections / Categories
    if (this.content && (this.content.collectionId || this.content.collectionIds || this.content.categoriesIds)) {
      this.sections.push({
        id: 'collections',
        num: index++,
        title: 'Collections & Categories',
        isEnabled: true
      });
    }

    // 10. Social Links
    if (this.content && this.content.socialLinks) {
      const isEnabled = this.content.socialLinks.display !== false;
      this.sections.push({
        id: 'socialLinks',
        num: index++,
        title: 'Social Links',
        isEnabled: isEnabled
      });
    }
  }
  hasAnyTextEnabled(): boolean {
    return !!(this.content?.inputText?.some((item: any) => item.isRTE));
  }

  hasDisplayKeys(display: any): boolean {
    if (display?.hasOwnProperty('showImage') || display?.hasOwnProperty('showText') || display?.hasOwnProperty('showIcon') || display?.hasOwnProperty('showHeading') || display?.hasOwnProperty('showContent') || display?.hasOwnProperty('showIncludeditems') || display?.hasOwnProperty('showLink') || display?.showLink) {
      return true;
    }
    else {
      return false;
    }
  }
  editTextInput(item: any) {
    this.currentEditTextItem = item;
    this.activeSubView = 'text-editor';
  }
  toggleTextItem(item: any) {
    this.currentEditTextItem = this.currentEditTextItem === item ? null : item;
  }

  goBackToMain() {
    this.activeSubView = 'main';
    this.currentEditTextItem = null;
  }

  onToggleChange(type: string) {
    if (type === 'showIncludeditems') {
      this.imageUpdated();
    }
    this.initializeSections();
  }

  get showButtonsToggle(): boolean {
    if (this.action && this.action.hasOwnProperty('display')) {
      return this.action.display ?? false;
    }
    return this.content?.display?.showButton ?? false;
  }

  set showButtonsToggle(val: boolean) {
    if (this.action && this.action.hasOwnProperty('display')) {
      this.action.display = val;
    } else if (this.content?.display) {
      this.content.display.showButton = val;
    }
  }

  enableButtons() {
    if (this.action) {
      this.action.display = true;
    } else if (this.content?.display) {
      this.content.display.showButton = true;
    }
    this.onToggleChange('showButton');
  }

  getAllCategories() {
    // let payload = {
    //   businessId: this._dbService.getBusinessId(),
    //   searchText: '',
    //   pageNo: 0,
    //   pageSize: 1000
    // }
    // this.productService.getcategoriesList(payload).subscribe((response: any) => {
    //   this.categoryList = response?.data?.data;
    // })
  }




  onSelectAllCategory(checkboxElement) {
    if (checkboxElement.checked) {
      // this.content.categoriesIds = this.categoryList.map((element) => element.categoryId);
      this.changeCategoryComponent('true');
    } else {
      this.changeCategoryComponent('false');
    }
  }



  onCategorySelect(categoryId: any) {
    this.eventEmitter.categoryListEvent.emit(categoryId);
  }
  changeCategoryComponent(allCategoryCheckbox?: string) {
    if (allCategoryCheckbox === 'true') {
      this.eventEmitter.categoryListEvent.emit('ALL');
    }
    else {
      this.eventEmitter.categoryListEvent.emit('DESELECTION');
    }
  }



  getCategoryName(categoryId: string) {
    return this.categoryList.filter((category) => category.categoryId == categoryId)?.[0]?.categoryName;
  }

  screenWidth: any;
  @HostListener('window:resize', ['$event'])
  screenSize(event?: any) {
    this.screenWidth = window.innerWidth;
  }

  ChannelType = ChannelType
  searchBox = new FormControl();
  searchLocation: any;
  searchResults: Observable<string[]> | any;
  locations: any = [];
  collectionList: any[] = [];
  lastListItem: any;
  private listItemTemplate: any = null;
  menuList: any = [];

  openListItem(data: any, index: number = 0) {
    let height = window.innerWidth > 475 ? '85vh' : '100vh';
    if (this.sectionType.includes('carouselBanner')) {
      this._localEventEmitterService.openMultiBannerCarousel.emit({ open: true, data: data })
    }
    else {
      this.eventEmitterService.secondaryEditor.emit({ data: { tab: 'LIST_ITEM', listItem: data, listItemLabel: this.content.listItem?.label || 'Items', newItem: false, listItemIndex: index } });
      // this.dialogSercvice.openDialog(ListItemComponentComponent, height,
      //   '35%', { data: data, newItem: false, sectionId: this.sectionId, templatePage: this.templatePage, currentPageIndex: this.currentPageIndex, showImage: this.content?.hasOwnProperty('display') && this.content.display.hasOwnProperty('showImage') ? this.content.display.showImage : true});
    }
  }

  deleteListItem(index: number) {
    this.content.listItem.data.splice(index, 1);
  }
  addNewListItem() {
    if (this.sectionType == 'videogrid' && !this.content.display.showImage) {
      this.content.listItem.data.push({
        "video": {
          "id": "video1",
          "url": "https://d2z9497xp8xb12.cloudfront.net/prod-images/430520c17695185862112year.mp4",
          "altText": "Test",
          "position": {
            "x": 50,
            "y": 50
          }
        }
      })
    }
    else {
      let height = window.innerWidth > 475 ? '85vh' : '100vh';
      console.log(this.content.listItem.data[0]);
      let data = this.content.listItem.data?.length > 0
        ? JSON.parse(JSON.stringify(this.content.listItem.data[0]))
        : (this.lastListItem || this.listItemTemplate || this.content.listItem?._template);
      if (data) {
        data = JSON.parse(JSON.stringify(data));
      }
      if (!data && this.sectionType !== 'banner' && this.sectionType !== 'header') {
        this.eventEmitterService.openSnack('Cannot add item — please refresh the section', 'OK');
        return;
      }
      if (this.sectionType === 'banner' || this.sectionType === 'header') {
        data = {
          "inputText": [
            {
              "label": "Text",
              "value": "",
              "isRTE": false
            }
          ]
        }
      }
      // let dialog = this.dialogSercvice.openDialog(ListItemComponentComponent, height,
      //   '35%', { data: data, newItem: true, buttonData: false, templatePage: this.templatePage, currentPageIndex: this.currentPageIndex });

      // dialog.afterClosed().subscribe((res: any) => {
      //   if (res.data) {
      //     if (res.data.hasOwnProperty('image')) {
      //       res.data.image.id = this.content.listItem.data.length + 1;
      //     }
      //     this.content.listItem.data.push(res.data);
      //   }
      // })
      this.eventEmitterService.secondaryEditor.emit({ data: { tab: 'LIST_ITEM', listItem: data, newItem: true } });
    }
  }
  dropCategory(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.content.categoriesIds, event.previousIndex, event.currentIndex);
    this.eventEmitter.categoryListEvent.emit();
  }
  addNewButton() {
    let newButton: ButtonModel = {
      "content": {
        "linkType": RedirectionLinkType.External,
        "label": "Button",
        "redirectionUrl": "",
        "pageId": "",
        "newTab": false,
        "showIcon": false,
        "icon": {
          "id": "icon1",
          "url": "",
          "iconPosition": "left",
          "altText": "Icon"
        }
      },
      "styles": {
        "type": this.action?.buttons.length == 0 || this.action?.buttons[0].styles.type === 'Solid' ? "Outline" : 'Solid',
        "shape": "Round"
      },
      "id": "btn" + (this.action?.buttons.length ? this.action?.buttons.length + 1 : 1)
    }

    this.action?.buttons.push(newButton)
    const newBtn = this.action!.buttons[this.action!.buttons.length - 1];
    this.eventEmitterService.secondaryEditor.emit({
      data: {
        tab: 'BUTTON_EDITOR',
        buttonData: newBtn.content,
        buttonStyle: newBtn.styles,
        componentId: this.sectionId,
        btnId: newBtn.id,
      }
    });
  }

  editButton(button: ButtonModel) {
    this.eventEmitterService.secondaryEditor.emit({
      data: {
        tab: 'BUTTON_EDITOR',
        buttonData: button.content ?? button,
        buttonStyle: button.styles,
        componentId: this.sectionId,
        btnId: button.id,
        // color: section.styles?.background?.accentColor ?? '',
        // backgroundInfo: section.styles?.background
      }
    },);
    // let height = window.innerWidth > 475 ? 'auto' : '100vh';
    // let dialog = this.dialogSercvice.openDialog(ListItemComponentComponent, height,
    //   '400px', { data: button, newItem: false, buttonData: true, templatePage: this.templatePage, currentPageIndex: this.currentPageIndex });
  }

  deleteButton(index: number) {
    this.action?.buttons.splice(index, 1)
  }

  changeSiteNameAndLogo() {
    try {

      const components = this.templatePage[this.currentPageIndex].components;
      if (!components[0].sectionType.includes("header"))
        return;
      const idx = components.length - 1;

      if (this.content.siteNameAndLogo == "same as header") {

        const socialChannels = components[0].content.socialLinks.channels;
        const logo = components[0].content.logo;
        const siteName = components[0].content.siteName;

        if (idx > -1) {
          components[idx].content.siteName = siteName;
          components[idx].content.logo = logo;
          components[idx].content.socialLinks.channels = socialChannels;
        }
      } else {
        components[idx].content.siteName = { ...components[idx]?.content?.siteName };
        components[idx].content.logo = { ...components[idx]?.content?.logo };
        components[idx].content.socialLinks.channels = [...components[idx]?.content?.socialLinks?.channels];

      }
    } catch (exception) {

    }

  }
  openAddProdcutsEditor(listItem: any, item: any) {
    // const dialogref = this.dialogSercvice.openDialog(
    //   AddProductsEditorComponent,
    //   '400px', '400px',
    //   {
    //     video: item,
    //     videoList: listItem
    //   }
    // );
    // dialogref.afterClosed().subscribe((res: any) => {
    //   if (res) {
    //     this.content.listItem.data.forEach((video: any) => {
    //       if (video.video.id === item.video.id) {
    //         video.video.products = res.selectedProducts;
    //       }
    //     })
    //   }
    //   console.log("video content", this.content.listItem.data);
    // });
  }
  openLogoStyleEditor() {
    // let height = window.innerWidth > 475 ? 'auto' : '100vh';
    // this.dialogSercvice.openDialog(LogoEditorComponent, height, '430px', { data: this.content.logo, siteName: this.content.siteName.value, bgColor: this.color })
    this.eventEmitterService.secondaryEditor.emit({ data: { tab: 'LOGO_EDITOR' } })
  }

  // addedChannels: any
  addNewChannel() {
    let newData: FooterSocialChannelModel = {
      type: ChannelType.FACEBOOK,
      url: '',
      link: ''
    };
    // let dialog = this.dialogSercvice.openDialog(AddSocialChannelsComponent, 'auto', '430px', { socialLink: newData, newItem: true })
    // dialog.afterClosed().subscribe((res: any) => {
    //   if (res.data) {
    //     this.content.socialLinks.channels.push(res.data);
    //
    //     // this.addedChannels = res.data
    //   }
    // })
    this.eventEmitterService.secondaryEditor.emit({ data: { tab: 'SOCIAL_CHANNEL', socialLink: newData, newItem: true } });
  }

  editChannel(channel: any) {
    // let dialog = this.dialogSercvice.openDialog(AddSocialChannelsComponent, 'auto', '430px', { socialLink: channel, newItem: false })
    this.eventEmitterService.secondaryEditor.emit({ data: { tab: 'SOCIAL_CHANNEL', socialLink: channel, newItem: false } });
  }

  deleteChannel(index: number) {
    this.content.socialLinks.channels.splice(index, 1);
  }

  regerateContent(inputText) {
    if (this.loading == inputText.label)
      return;
    this.loading = inputText.label;
    const bDetails = JSON.parse(localStorage.getItem("bDetails") ?? "");
    if (!bDetails)
      return;
    const payload = {
      "dataId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "subIndustryId": bDetails.subIndustryId,
      "businessId": bDetails.id,
      // "businessName": "string", industryId
      "customPrompt": "",
      "label": inputText.label,
      "value": inputText.value,
      "suggestedDataType": "COMPONENT",
      "tone": "PROFESSIONAL",
      // "wordLimit": 0
    }
    this.websiteService.regenerateIndividualV2(payload).subscribe((response: any) => {
      inputText.value = response.data;
      this.loading = null;
    }, (error) => {
      this.loading = null;
    })
  }

  getSanitizedData(value: string) {
    if (!value)
      return ''
    const regex = /(<([^>]+)>)/ig;
    return value.replace(regex, '');
  }
  removeHtml(value: string): string {
    if (!value) return '';

    const div = document.createElement('div');
    div.innerHTML = value;

    let text = div.textContent || div.innerText || '';

    // replace non-breaking space with normal space
    text = text.replace(/\u00A0/g, ' ').trim();

    // 🔹 limit to 33 chars
    if (text.length > 33) {
      return text.slice(0, 33) + '...';
    }

    return text;
  }
  getPlainText(value: string): string {
    if (!value) return '';
    const clean = value.replace(/(<([^>]+)>)/ig, '');
    return clean.length <= 33 ? clean : clean.slice(0, 33) + '...';
  }

  deleteData(type: any, index: number) {
    this.warningPopup(type).subscribe((res: any) => {
      if (res.delete) {
        if (type === 'LIST_ITEM') {
          this.lastListItem = this.content?.listItem?.data?.[index]
          this.deleteListItem(index);
        } else if (type === 'BUTTON') {
          this.deleteButton(index);
        } else if (type === 'SOCIAL_LINK') {
          this.deleteChannel(index);
        }
      }
    })
  }

  warningPopup(type: any) {
    let width = window.innerWidth > 475 ? '400px' : '94%'
    let height = window.innerWidth > 475 ? '' : '200px'
    let warningPopupModel = this.dialogSercvice.openDialog(
      WarningPopupComponent,
      height,
      width,
      { type: type },
      'rounded-popup'
    );

    return warningPopupModel.afterClosed()
  }

  search() {
    this._mapservice.searchAddress(this.searchLocation).subscribe(
      (res: any) => {
        if (res.features.length > 0) {
          this.locations = res.features;
          this.searchResults = this.searchBox.valueChanges.pipe(
            startWith(''),
            map((value) => this._searchFilter(value))
          );
        }
      },
      (err) => {
      }
    );
  }

  private _searchFilter(value: any) {
    const filterValue = value.toLowerCase();

    return this.locations.filter((option: any) =>
      option.place_name.toLowerCase().includes(filterValue)
    );
  }

  selectedLocations(location: any) {
    this.content.address.name = this.searchLocation;
    this.content.address.longitude = location.center[0]
    this.content.address.latitude = location.center[1];
    this.eventEmitter.locationChangeCheck.emit(this.content.address);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.content.listItem.data, event.previousIndex, event.currentIndex);
  }
  dropCollection(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.content.collectionIds, event.previousIndex, event.currentIndex);
    this.eventEmitter.collectionsListEvent.emit();
  }
  getCollectionList() {
    let data = {
      businessId: this._dbService.getBusinessId(),
      pageNo: 0,
      pageSize: 100
    }
    this.productService.getCollectionList(data).subscribe(
      {
        next: (value: any) => {
          this.collectionList = value.data.data;
          if (this.content.hasOwnProperty('collectionId') && this.content.collectionId.length == 0) {
            this.content.collectionId = this.collectionList[0]?.collectionId;
            this.changeCollection(this.collectionList[0]?.collectionName);
          }
        },
        error: (err: any) => {
        }
      }
    )
  }

  getMenuList() {
    // let data = {
    //   businessId: this._dbService.getBusinessId(),
    // }
    // this.ecomService.getMenuList(data).subscribe({
    //   next: (value: any) => {
    //     this.menuList = Array.isArray(value?.data?.data)
    //       ? value.data.data
    //       : (Array.isArray(value?.data) ? value.data : []);
    //     if (this.content?.hasOwnProperty('menuId') && !this.content.menuId && this.menuList.length) {
    //       this.content.menuId = this.menuList[0]?.id;
    //     }
    //     this.changeMenuList();
    //   },
    //   error: (err: any) => {
    //     console.error("Error fetching menu list", err);
    //   }
    // });
  }

  changeMenuList() {
    this.eventEmitter.menuList.emit()
  }

  getMenuName(menuId: string) {
    return this.menuList.filter((menu) => menu.id == menuId)?.[0]?.name;
  }

  onSelectAllCollection(checkboxElement) {
    if (checkboxElement.checked) {
      this.content.collectionIds = this.collectionList.map((element) => element.collectionId);
      this.changeCollectionComponent();
    } else {
      this.content.collectionIds = [];
      this.changeCollectionComponent();
    }
  }

  // selectCollection(collection: any, allCollectionCheckbox) {
  //
  //   if (!this.content.collectionIds.includes(collection.collectionId)) {
  //     this.content.collectionIds.push(collection.collectionId);
  //   } else {
  //     this.content.collectionIds = this.content.collectionIds.filter((data: any) => data != collection.collectionId);
  //     allCollectionCheckbox = this.content.collectionIds.length === this.collectionList.length;
  //   }
  //   this.changeCollectionComponent();
  // }


  changeCollection(collectionName) {
    if (this.sectionType === 'featuredProduct' || this.sectionType == 'featuredproductv2')
      this.eventEmitter.featureCollectionList.emit()
    else if (this.sectionType === 'categoryProduct')
      this.eventEmitter.categoryProductList.emit(this.content.collectionId)
    // else if (this.sectionType === 'featuredCategory')
    //   this.eventEmitter.categoryListEvent.emit()

    this.content.inputText[0].value = collectionName;
  }

  changeCollectionComponent() {
    this.eventEmitter.collectionsListEvent.emit();
  }
  getCollectionName(collectionId: string) {
    return this.collectionList.filter((collection) => collection.collectionId == collectionId)?.[0]?.collectionName;
  }
  iconUpdated() {
    if (this.content?.display?.showIcon)
      if (this.content.display.hasOwnProperty('showImage'))
        this.content.display.showImage = false;

    if (this.style?.textPosition)
      this.style.textPosition = TextPosition.BELOW_IMAGE
  }
  imageUpdated() {
    if (this.content.display?.showImage && this.content.display?.hasOwnProperty('showIcon'))
      this.content.display.showIcon = false;
    if (this.sectionType === 'videogrid') {
      this.content.listItem.data = this.content.display.showImage ? [
        {
          "image": {
            "id": "img1",
            "url": "https://i.pinimg.com/474x/3d/99/56/3d99564a25cb0590017f97903dc5e0d6.jpg",
            "altText": "Test",
            "content": {
              "linkType": "Page",
              "label": "More Info",
              "redirectionUrl": "",
              "newTab": false
            },
            "position": {
              "x": 0,
              "y": 0
            }
          }
        },
        {
          "image": {
            "id": "img2",
            "url": "https://i.pinimg.com/474x/3d/99/56/3d99564a25cb0590017f97903dc5e0d6.jpg",
            "altText": "Test",
            "content": {
              "linkType": "Page",
              "label": "More Info",
              "redirectionUrl": "",
              "newTab": false
            },
            "position": {
              "x": 0,
              "y": 0
            }
          }
        },
        {
          "image": {
            "id": "img3",
            "url": "https://i.pinimg.com/474x/3d/99/56/3d99564a25cb0590017f97903dc5e0d6.jpg",
            "altText": "Test",
            "content": {
              "linkType": "Page",
              "label": "More Info",
              "redirectionUrl": "",
              "newTab": false
            },
            "position": {
              "x": 0,
              "y": 0
            }
          }
        }
      ] : [
        {
          "video": {
            "id": "video3",
            "url": "//www.lucirajewelry.com/cdn/shop/videos/c/vp/6f39f797cd7e4c7c94aa2e1b4bcf457b/6f39f797cd7e4c7c94aa2e1b4bcf457b.HD-1080p-2.5Mbps-55011497.mp4?v=0",
            "altText": "Test",
            "position": {
              "x": 50,
              "y": 50
            },
            "isVideoPlaying": false,
            "description": "Happy Parents | Safe Kids🧡(customer feedback, customer review, client testimonial, real customer)",
            "products": []
          }
        },
        {
          "video": {
            "id": "video4",
            "url": "//www.lucirajewelry.com/cdn/shop/videos/c/vp/1708dd89d83f490cb2182445fceaf6cb/1708dd89d83f490cb2182445fceaf6cb.HD-1080p-4.8Mbps-66567546.mp4?v=0",
            "altText": "Test",
            "position": {
              "x": 50,
              "y": 50
            },
            "isVideoPlaying": false,
            "description": "Happy Parents | Safe Kids🧡(customer feedback, customer review, client testimonial, real customer)",
            "products": []
          }
        },
        {
          "video": {
            "id": "video5",
            "url": "//www.lucirajewelry.com/cdn/shop/videos/c/vp/ef21629570184348bdce61b21e913c82/ef21629570184348bdce61b21e913c82.HD-1080p-3.3Mbps-55148000.mp4?v=0",
            "altText": "Test",
            "position": {
              "x": 50,
              "y": 50
            },
            "isVideoPlaying": false,
            "description": "Happy Parents | Safe Kids🧡(customer feedback, customer review, client testimonial, real customer)",
            "products": []
          }
        }
      ]
      this.content.listItem.label = this.content.display?.showImage ? 'Images' : 'Videos';
    }
  }

  onTextValueChange() {
    this.dyanmicService.markSectionForCheck(this.sectionId);
  }

  updateColumns() {
    const header = this.content.productTableDataList[0];
    const currentColumns = header.length;
    const requiredColumns = this.content.numberOfColumns;
    if (requiredColumns > currentColumns) {
      const columnsToAdd = requiredColumns - currentColumns;
      for (let i = 0; i < columnsToAdd; i++) {
        const newColumnNumber = this.content.productTableDataList[0].length + 1;
        this.content.productTableDataList.forEach((row: any[], rowIndex: number) => {
          row.push({ columnCell: newColumnNumber, value: rowIndex === 0 ? 'Heading' : 'Description' });
        });
      }
    } else if (requiredColumns < currentColumns) {
      const columnsToRemove = currentColumns - requiredColumns;
      for (let i = 0; i < columnsToRemove; i++) {
        this.content.productTableDataList.forEach((row: any[]) => {
          if (row.length > 1) row.pop();
        });
      }
    }
  }

  updateRows() {
    const table = this.content.productTableDataList;
    const currentRows = table.length - 1;
    if (this.content.numberOfRows > currentRows) {
      const rowsToAdd = this.content.numberOfRows - currentRows;
      for (let i = 0; i < rowsToAdd; i++) {
        const newRow: any[] = [];
        for (let col = 1; col <= this.content.numberOfColumns; col++) {
          newRow.push({ columnCell: col, value: `Column ${col}` });
        }
        table.push(newRow);
      }
    } else if (this.content.numberOfRows < currentRows) {
      const rowsToRemove = currentRows - this.content.numberOfRows;
      for (let i = 0; i < rowsToRemove; i++) {
        if (table.length > 1) table.pop();
      }
    }
  }
}